import r from "../../../css/img/app-launcher-white.svg.js";
import e from "../../../css/img/itc-logo-white-text.svg.js";
import a from "../../../css/img/kaseya-logo-login.svg.js";
import t from "../../../css/img/email-dark-mode.svg.js";
var i = {
    itcPrimary: "#67C5D4",
    itcPrimary20: "rgba(103, 197, 212, 0.2)",
    itcPrimaryBackground: "#22272C",
    itcPrimaryText: "#C7C7C7",
    itcInAppText: "#C7C7C7",
    itcInAppTextDescription: "#C7C7C7",
    itcSecondaryText: "#B6B6B6",
    itcLightText: "#C7C7C7",
    itcMixedText: "#B6B6B6",
    itcMutedText: "#969696",
    itcPlaceholderText: "#ABABAB",
    itcDisabledText: "#7D7D7D",
    itcDisabledBackground: "#515457",
    itcBorder: "#515457",
    itcFormElementBorder: "#7D7D7D",
    itcDisabledBorder: "#515457",
    itcSecondaryBackground: "#343A40",
    itcSecondaryBorder: "#67C5D4",
    itcInfoBackground: "#29466A",
    itcSuccessBackground: "#275248",
    itcWarningBackground: "#40341B",
    itcErrorBackground: "#492229",
    itcIcon: "#969696",
    itcPrimaryHover: "#31E3FF",
    itcAccentHover: "#38E080",
    itcButtonText: "#20262C",
    itcButtonDangerText: "#FFFFFF",
    itcButtonSecondaryDisabledText: "#515457",
    itcButtonSecondaryHoverBackground: "rgba(49,227,255,.15)",
    itcButtonDangerHoverBackground: "rgba(217,83,79,.15)",
    itcTooltipBackground: "#35434C",
    itcTooltipText: "#E5E5E5",
    itcTooltipTitle: "#E5E5E5",
    itcTooltipLink: "#67C5D4",
    itcTabBorder: "#515457",
    itcTabText: "#001D30",
    itcTabActiveText: "#6BC5D3",
    itcTabActiveBorder: "#6BC5D3",
    itcTabHoverBorder: "#969696",
    itcTabDisabled: "#515457",
    itcTabBadgeBackground: "rgba(148, 147, 147, 0.2)",
    itcTabActiveBadgeBackground: "rgba(49, 134, 218, 0.2)",
    itcTabHoverBadgeBackground: "rgba(148, 147, 147, 0.2)",
    itcDisabledCheckbox: "#969696",
    itcSecondaryButton: "#67C5D4",
    itcShadow: "rgba(0,0,0,.6)",
    itcToggleBackground: "#7D7D7D",
    itcEditableHover: "#343A40",
    itcGrayTagBackground: "#343A40",
    itcScrollbarFace: "rgba(229, 229, 229, 0.4)",
    itcDropdownItemSelected: "rgba(103, 197, 212, .15)",
    itcDropdownPanelBackground: "#272D33",
    itcDialogTopDivider: "#424548",
    itcDialogBottomDivider: "#424548",
    itcLoginAccent: "var(--itc-primary-color)",
    itcLoginAccentHover: "var(--itc-primary-hover-color)",
    itcAppLauncherPanelIcon: "url(".concat(r, ")"),
    itcTopbarButtonActive: "#343A40",
    itcTopbarButtonHover: "rgba(255, 255, 255, .12)",
    itcTopbarButtonText: "#C7C7C7",
    itcTopbarButtonTextActive: "#E5E5E5",
    itcTopbarDropdownTitle: "#969696",
    itcTopbarDropdownBackground: "#272D33",
    itcTopbarDropdownBorder: "#424548",
    itcTopbarDropdownText: "#C7C7C7",
    itcDotLoaderPrimary: "rgba(32, 38, 44, .8)",
    itcDotLoaderSecondary: "rgba(49, 227, 255, .8)",
    itcDotLoaderGhost: "rgba(49, 227, 255, .8)",
    itcPopoverText: "#C7C7C7",
    itcPopoverBackground: "#272D33",
    itcSidebarHeader: "#7D7D7D",
    itcSidebarItemHover: "#343A40",
    itcSidebarNavigationResizeButtonBorder: "#343A40",
    itcSidebarNavigationResizeButtonIcon: "#E8E8E8",
    itcSidebarItemActive: "#E5E5E5",
    itcSidebarOpaqueBox: "#000000",
    itcSidebarDrawerBorder: "#424548",
    itcInAppOpaqueBox: "rgba(2, 2, 2, 0.65)",
    itcInAppSearchBar: "#7D7D7D",
    itcInAppSearchIcon: "#969696",
    itcInAppResults: "#969696",
    itcInAppChevronIcon: "#67C5D4",
    itcVideoTagGreen: "rgba(103, 217, 150, 1)",
    itcVideoTagBlue: "rgba(85, 205, 242, 1)",
    itcVideoTagLavender: "rgba(205, 184, 245, 1)",
    itcVideoTagGrey: "rgba(0, 173, 67, 1)",
    itcVideoTagRed: "rgba(239, 83, 78, 1)",
    itcVideoTagPurple: "rgba(199, 88, 180, 1)",
    itcVideoTagTurqoise: "rgba(83, 198, 199, 1)",
    itcVideoTagOceanBlue: "rgba(91, 174, 255, 1)",
    itcVideoTagBitterweet: "rgba(255, 137, 137, 1)",
    itcVideoTagOrange: "rgba(251, 154, 40, 1)",
    itcVideoTagYellow: "rgba(222, 181, 76, 1)",
    itcVideoTagViolet: "rgba(124, 96, 247, 1)",
    itcVideoTagGreenBackground: "rgba(0, 173, 67, 0.3)",
    itcVideoTagBlueBackground: "rgba(85, 205, 242, 0.3)",
    itcVideoTagLavenderBackground: "rgba(205, 184, 245, 0.3)",
    itcVideoTagGreyBackground: "rgba(0, 173, 67, 0.3)",
    itcVideoTagRedBackground: "rgba(201, 48, 44, 0.3)",
    itcVideoTagPurpleBackground: "rgba(154, 79, 141, 0.3)",
    itcVideoTagTurqoiseBackground: "rgba(32, 126, 156, 0.3)",
    itcVideoTagOceanBlueBackground: "rgba(49, 134, 218, 0.3)",
    itcVideoTagBitterweetBackground: "rgba(252, 73, 48, 0.3)",
    itcVideoTagOrangeBackground: "rgba(185, 118, 12, 0.3)",
    itcVideoTagYellowBackground: "rgba(180, 134, 18, 0.3)",
    itcVideoTagVioletBackground: "rgba(79, 74, 204, 0.3)",
    itcInAppSidebarHover: "#343A40",
    itcInAppSidebarActive: "#343A40",
    itcInAppSidebarItemActive: "#67C5D4"
  },
  c = {
    itcLink: i.itcPrimary
  },
  o = {
    colorVariables: {
      primaryAccent: "#1CC0BE",
      primaryBorder: "#40494F",
      primaryText: "#E5E5E5",
      primaryBackground: "#22272B",
      secondaryBackground: "#181B1E",
      secondaryBorder: "#40494F",
      secondaryAccent: "#869AAB",
      disabled: "#40494F",
      active: "#67C5D4"
    },
    buttonVariables: {
      buttonBackground: "#22272B",
      buttonDisabledBackground: "transparent",
      buttonDisabledBorder: "#40494F"
    },
    formElementVariables: {
      formElementBackground: "#181B1E",
      formElementBorder: "transparent",
      formElementBorderFocused: "#40494F",
      formElementDisabled: "#444",
      kaseyaUiFormElementDisabled: "#515457",
      formElementEditable: "#343A40",
      formElementText: "#E5E5E5"
    },
    formInputVariables: {
      formInputText: "#E5E5E5",
      formInputBorder: "#7D7D7D"
    },
    removableTagVariables: {
      itcRemovableTagText: "#E5E5E5",
      itcRemovableTagBackground: "rgba(103, 197, 212, 0.3)",
      itcRemovableTagButton: "#99EBF8"
    },
    tagVariables: {
      itcTagBlack: "#E5E5E5",
      itcTagBlackBackground: "rgb(148, 147, 147, 0.3)",
      itcTagBittersweet: "#FFA4A4",
      itcTagBittersweetBackground: "rgb(252, 73, 77, 0.3)",
      itcTagGreen: "#67D996",
      itcTagGreenBackground: "rgb(63, 149, 100, 0.3)",
      itcTagLavender: "#D0B7FF",
      itcTagLavenderBackground: "rgb(156, 119, 227, 0.3)",
      itcTagOrange: "#FFB053",
      itcTagOrangeBackground: "rgb(185, 118, 12, 0.3)",
      itcTagOceanBlue: "#87C4FF",
      itcTagOceanBlueBackground: "rgb(49, 134, 218, 0.3)",
      itcTagPurple: "#F890E6",
      itcTagPurpleBackground: "rgb(154, 79, 141, 0.3)",
      itcTagRed: "#EF534E",
      itcTagRedBackground: "rgb(201, 77, 44, 0.3)",
      itcTagSkyBlue: "#55CDF2",
      itcTagSkyBlueBackground: "rgb(32, 126, 156, 0.3)",
      itcTagTurqoise: "#5AD4D6",
      itcTagTurqoiseBackground: "rgb(32, 126, 156, 0.3)",
      itcTagViolet: "#B6A6FF",
      itcTagVioletBackground: "rgb(79, 74, 204, 0.3)",
      itcTagYellow: "#E8BD4F",
      itcTagYellowBackground: "rgb(180, 134, 18, 0.3)"
    },
    typeaheadVariables: {
      typeaheadSelectedItem: "#333"
    },
    itcVariables: i,
    itcExtendedVariables: c,
    spinner: "255, 255, 255",
    loginSwirl1: "#181B1E",
    loginSwirl2: "#1E2329",
    loginSwirl3: "#343A40",
    loginSwirl4: "#181B1E",
    itcIconImage: "url(".concat(e, ")"),
    kaseyaFooterLogo: "url(".concat(a, ")"),
    emailIcon: "url(".concat(t, ")"),
    theme: "#181B1E"
  };
export { o as DarkTheme };